import theme from '@styles/theme';
const getMarginValue = (margin: string | undefined): string | number => {
  if (!margin || margin === 'without') return 0;
  return `${margin}px`;
};
export default {
  newSpacingBlock: (marginTop: string | undefined, marginBottom: string | undefined, background: string | undefined) => ({
    background: background || theme.rawColors.neutralWhite,
    pt: getMarginValue(marginTop),
    pb: getMarginValue(marginBottom),
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  })
};